import { mapState } from 'vuex';
import range from 'lodash/range';
import padStart from 'lodash/padStart';
import get from 'lodash/get';
export default {
  name: 'IsFMAccmgmtrowdetail',
  props: {
    editedItem: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      actionButtons: [{
        title: this.$i18n_t('Common.reset'),
        action: 'reset',
        icon: 'fal fa-sync'
      }, {
        title: this.$i18n_t('Common.save'),
        tooltip: this.$i18n_t('Common.save'),
        icon: 'fas fa-save',
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }],
      panel: null,
      dateFromMenu: false,
      dateFromPosition: {},
      dateToMenu: false,
      dateToPosition: {},
      searchDays: '',
      valid: false,
      lclId: null,
      lclTwinId1: null,
      lclTwinId2: null,
      lclEmail: null,
      lclUsagePerWeek: null,
      lclDays: [],
      lclUserId: null,
      lclDateFrom: null,
      lclDateTo: null,
      daysList: [{
        dayId: 1,
        dayText: this.$i18n_t('Common.Monday')
      }, {
        dayId: 2,
        dayText: this.$i18n_t('Common.Tuesday')
      }, {
        dayId: 3,
        dayText: this.$i18n_t('Common.Wednesday')
      }, {
        dayId: 4,
        dayText: this.$i18n_t('Common.Thursday')
      }, {
        dayId: 5,
        dayText: this.$i18n_t('Common.Friday')
      }, {
        dayId: 6,
        dayText: this.$i18n_t('Common.Saturday')
      }, {
        dayId: 0,
        dayText: this.$i18n_t('Common.Sunday')
      }],
      lclTimeFromHour: null,
      lclTimeFromMinute: '00',
      lclTimeToHour: null,
      lclTimeToMinute: '00',
      hourList: range(0, 24),
      minuteList: range(0, 60, 5),
      rulesDateTo: [v => {
        if (v < this.lclDateFrom) {
          return this.$i18n_t('IS.FM.AccessMgmt.dateBigThanFrom');
        } else {
          return true;
        }
      }]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    lclTimeFrom() {
      return this.lclTimeFromHour ? `${padStart(this.lclTimeFromHour, 2, '0')}:${padStart(this.lclTimeFromMinute, 2, '0')}` : null;
    },
    lclTimeTo() {
      return this.lclTimeToHour ? `${padStart(this.lclTimeToHour, 2, '0')}:${padStart(this.lclTimeToMinute, 2, '0')}` : null;
    },
    rolloverDayCaption() {
      return this.lclTimeTo < this.lclTimeFrom && this.lclTimeTo !== '00:00' ? `${this.$i18n_t('IS.FM.AccessMgmt.dayRollover')} ☝🏼` : null;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    editedItem(val) {
      this.initForm(val);
    },
    lclTwinId1(newV, oldV) {
      if (oldV !== null) {
        // if a building/room is selected, reset the selection of the door, otherwise the tree won't build correctly
        this.lclTwinId2 = undefined;
      }
    }
  },
  mounted() {
    if (this.editedItem) {
      this.initForm(this.editedItem);
    }
    this.$refs.form.validate();
    this.hourList = this.hourList.map(hour => padStart(hour, 2, '0'));
    this.minuteList = this.minuteList.map(minute => padStart(minute, 2, '0'));
  },
  methods: {
    allowedStep: m => m % 10 === 0,
    userSelected(a) {
      this.lclUserId = a.id;
      this.lclEmail = a.email;
    },
    isValidDoorParent(entry) {
      if (get(entry, 'data.tags', []).findIndex(tag => ['building', 'room'].indexOf(tag.toLowerCase()) >= 0) >= 0) {
        return true;
      }
      return ['building', 'room'].indexOf(get(entry, 'data.type', '')) >= 0;
    },
    isValidDoor(entry) {
      return get(entry, 'data.isFm.doorId') && entry.data.isFm.doorId.trim() !== '';
    },
    close() {
      this.initForm();
      this.$emit('close');
    },
    validate() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.snackbar = true;
      }
    },
    fromDatePicked(dateObject) {
      this.lclDateFrom = new Date(dateObject.from * 1000);
    },
    toDatePicked(dateObject) {
      this.lclDateTo = new Date(dateObject.from * 1000);
    },
    handleSubmit() {
      this.validate();
      if (this.valid) {
        // make sure to only get the "date" component from the date-picker
        let dateFrom = this.lclDateFrom ? new Date(this.lclDateFrom).toISOString() : null;
        if (dateFrom) {
          dateFrom = dateFrom.split('T')[0];
        }
        let dateTo = this.lclDateTo ? new Date(this.lclDateTo).toISOString() : null;
        if (dateTo) {
          dateTo = dateTo.split('T')[0];
        }
        this.$emit('save', {
          id: this.lclId,
          userId: this.lclUserId,
          dtwinId: this.lclTwinId1,
          accessObject: this.lclTwinId2,
          data: {
            days: this.lclDays,
            usagePerWeek: this.lclUsagePerWeek,
            dateFrom,
            dateTo,
            timeFrom: this.lclTimeFrom,
            timeTo: this.lclTimeTo
          }
        });
        this.initForm();
      }
    },
    resetTimeRestriction() {
      this.lclTimeFromHour = null;
      this.lclTimeFromMinute = '00';
      this.lclTimeToHour = null;
      this.lclTimeToMinute = '00';
    },
    reset() {
      this.initForm();
    },
    initForm(val) {
      if (val) {
        this.lclId = val.id;
        this.lclTwinId1 = val.dtwinId;
        this.lclTwinId2 = val.accessObject;
        this.lclUserId = val.userId;
        if (val.user) {
          this.lclEmail = val.user.email;
        }
        if (val.data) {
          this.lclDays = val.data.days;
          this.lclDateFrom = val.data.dateFrom;
          this.lclDateTo = val.data.dateTo;
          this.lclUsagePerWeek = val.data.usagePerWeek;
          const timeFromComponents = val.data.timeFrom ? val.data.timeFrom.split(':') : null;
          this.lclTimeFromHour = get(timeFromComponents, '[0]');
          this.lclTimeFromMinute = get(timeFromComponents, '[1]');
          const timeToComponents = val.data.timeTo ? val.data.timeTo.split(':') : null;
          this.lclTimeToHour = get(timeToComponents, '[0]');
          this.lclTimeToMinute = get(timeToComponents, '[1]');
          if (val.data.days || val.data.timeFrom || val.data.usagePerWeek) {
            this.panel = 0;
          }
        }
      } else {
        this.lclUserId = null;
        this.lclTwinId1 = null;
        this.lclTwinId2 = null;
        this.panel = null;
        this.lclDateFrom = null;
        this.lclDateTo = null;
        this.lclDays = [];
        this.lclUsagePerWeek = null;
        this.resetTimeRestriction();
      }
    }
  }
};